import { Navigate, Outlet } from 'react-router-dom';
import { DEFAULT_LOCAL_PATH } from '../constents';
import { useSelector } from 'react-redux';

const PrivateRouts = () => {
  const { user } = useSelector((store) => store.auth);
  return user ? <Outlet /> : <Navigate to={DEFAULT_LOCAL_PATH} />;
};

export default PrivateRouts;
